import React from 'react';

import cx from 'classnames';
import getColourPropsByColourSchemaAndCampaignColor from 'utils/getColourPropsByColourSchemaAndCampaignColor';

import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import VerticalTile, {
  VerticalTileProps,
} from 'components/VerticalTile/VerticalTile';
import { ICampaignContent } from 'models/campaignContent';

interface IProps extends VerticalTileProps {
  campaignContent: ICampaignContent;
  colour: string;
}
const VerticalTileCampaignContent: React.FC<IProps> = ({
  campaignContent,
  colour,
  className,
  style = {},
  ...props
}) => {
  const { backgroundColor, btnVariant, textColorClass } =
    getColourPropsByColourSchemaAndCampaignColor(
      colour,
      campaignContent.colour_schema?.name,
    );
  return (
    <VerticalTile
      imageURL={campaignContent.content_media.url}
      imageAlt={campaignContent.content_media_alt}
      className={cx('w-100 flex-grow-1', className)}
      style={{ ...style, backgroundColor }}
      {...props}
    >
      <h2
        data-content="campaign_content_heading"
        className={cx('text-center', textColorClass)}
      >
        {campaignContent.heading}
      </h2>
      <div
        className={cx(textColorClass)}
        dangerouslySetInnerHTML={{ __html: campaignContent.content_brief }}
      />
      <LinkButtonRow
        btnProps={{ variant: btnVariant }}
        links={campaignContent.links || []}
      />
    </VerticalTile>
  );
};

export default VerticalTileCampaignContent;
